import { useTranslation } from 'react-i18next';
import { Leaf, Zap, Snowflake, Dna } from 'lucide-react';
import img007 from '../assets/007.jpg';
import img008 from '../assets/008.jpg';
import img009 from '../assets/009.jpg';
import img010 from '../assets/010.jpg';

const PILLAR_KEYS = ['systemic', 'detox', 'cryo', 'cellular'];
const ICONS = [<Zap size={22} />, <Leaf size={22} />, <Snowflake size={22} />, <Dna size={22} />];
const IMAGES = [img007, img008, img009, img010];

export const LongevityPillars = () => {
  const { t } = useTranslation();

  const pillars = [
    {
      titleKey: 'Systemic Reset & Vitality Boost',
      body: t('book.pages.007.body'),
      result: t('book.pages.007.meta_result'),
      protocols: [t('book.pages.007.meta_protocols')]
    },
    {
      titleKey: 'Holistic Detox & Performance',
      body: t('book.pages.008.body'),
      result: t('book.pages.008.meta_result'),
      protocols: [t('book.pages.008.meta_protocols')]
    },
    {
      titleKey: 'Cold Therapy & Biohacking',
      body: t('book.pages.009.body'),
      result: t('book.pages.009.meta_result'),
      protocols: [t('book.pages.009.meta_protocols')]
    },
    {
      titleKey: 'Cellular Rejuvenation & Longevity',
      body: t('book.pages.010.body'),
      result: t('book.pages.010.meta_result'),
      protocols: [t('book.pages.010.meta_protocols')]
    },
  ];

  return (
    <section className="pillars-section" id="longevity" data-testid="longevity-section">
      <div className="container">
        <div className="pillars-header">
          <p className="section-label">{t('longevity.label')}</p>
          <h2>{t('longevity.heading')}</h2>
          <p>{t('longevity.subtitle')}</p>
        </div>
        <div className="pillars-grid">
          {pillars.map((pillar, i) => (
            <div key={i} className="pillar-card" data-testid={`pillar-card-${i}`}>
              <img src={IMAGES[i]} alt={pillar.titleKey} className="pillar-img" loading="lazy" />
              <div className="pillar-icon">{ICONS[i]}</div>
              <h3>{pillar.titleKey}</h3>
              <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', marginBottom: '8px' }}>{pillar.body}</p>
              {pillar.result && (
                <p style={{ fontSize: '0.8rem', color: 'var(--color-gold-2)', fontStyle: 'italic', marginBottom: '10px' }}>
                  <strong>{t('longevity.result_label')}:</strong> {pillar.result}
                </p>
              )}
              <div className="pillar-protocols">
                {pillar.protocols[0] && pillar.protocols[0].split('\u00b7').map((p, j) => (
                  <div key={j} className="pillar-protocol-item">{p.trim()}</div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
